import { Paginate } from './../models/paginate.model';
import { Response } from './../models/response.model';
import { BaseService } from './base/base.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { YourHistoricTest } from '../models/your-historic-test.model';



@Injectable({
  providedIn: 'root'
})
export class YourHistoricTestService extends BaseService {

  private modelName = 'resposta';

  constructor(
    protected http: HttpClient,
    protected baseService: BaseService

  ) {
    super(http);

  }

  get urlApi() {
    return environment.apiEndpoint + this.modelName;
  }

  getHistoricByUser(): Observable<Response<YourHistoricTest>> {
    return this.http.get<Response<YourHistoricTest>>(`${environment.apiEndpoint}/${this.modelName}`, { headers: this.baseService.createHeader });
  }

  getHistoricByUserPaged(obj: any): Observable<Response<Paginate<YourHistoricTest>>> {
    return this.http.get<Response<Paginate<YourHistoricTest>>>(`${environment.apiEndpoint}/${this.modelName}` + '/paginado' + this.baseService.paramsToQueryString(obj), { headers: this.baseService.createHeader });
  }

}
